import React from 'react';
import { ScrollView, Text, StyleSheet, View, TouchableOpacity, Platform, KeyboardAvoidingView, Keyboard, TouchableWithoutFeedback } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { Button, BackgroundGradient, Loader, Validate, TextInputContainer, SafeAreaView } from '../../components';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import Constants from 'expo-constants';
import { useHeaderHeight } from '@react-navigation/elements';
import { formatPhoneNumber } from '../../utils/Functions';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useLinkTo } from '@react-navigation/native';
import { FontAwesome5 } from '@expo/vector-icons';

const EmergencyContacts = (props) => {
  const [loading, setLoading] = React.useState(false);

  const defaultIsInvalid = { name1: false, phone1: false, email1: false, relationship1: false, name2: false, phone2: false, email2: false, relationship2: false, };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  let textInputs = {
    name1: React.useRef(null),
    phone1: React.useRef(null),
    email1: React.useRef(null),
    relationship1: React.useRef(null),
    name2: React.useRef(null),
    phone2: React.useRef(null),
    email2: React.useRef(null),
    relationship2: React.useRef(null),
  };

  const headerHeight = useHeaderHeight();
  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  React.useEffect(() => {
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (!props.signUpProgress.VerifyIdentity) {
      linkTo('/login');
    }
  }

  const checkEmergencyContacts = () => {
    if(checkEmergencyContact2() || checkEmergencyContact1()){
      props.setSkipEmergency(false);
      nextScreen();
    }
  }
  const checkEmergencyContact1 = () => {
    console.log('check emergency1');
    // name1
    if (!Validate.Name(props.emergencyContact1.name)) {
      setIsInvalid(prevState => { return { ...prevState, name1: true } });
      textInputs.name1.current.focus();
      return false;
    }
    // phone1 email1
    if ((!Validate.PhoneNumber(props.emergencyContact1.phone)) && (!Validate.Email(props.emergencyContact1.email))) {
      // phone1
      if (!Validate.PhoneNumber(props.emergencyContact1.phone)) {
        setIsInvalid(prevState => { return { ...prevState, phone1: true } });
        textInputs.phone1.current.focus();
        return false;
      }
      // email1
      if (!Validate.Email(props.emergencyContact1.email)) {
        setIsInvalid(prevState => { return { ...prevState, email1: true } });
        textInputs.email1.current.focus();
        return false;
      }
    }
    return true;
  };
  const checkEmergencyContact2 = () => {
    console.log('check emergency2');
    // name2
    if (!Validate.Name(props.emergencyContact2.name)) {
      setIsInvalid(prevState => { return { ...prevState, name2: true } });
      textInputs.name2.current.focus();
      return false;
    }
    if ((!Validate.PhoneNumber(props.emergencyContact2.phone)) && (!Validate.Email(props.emergencyContact2.email))){
      // phone2
      if (!Validate.PhoneNumber(props.emergencyContact2.phone)) {
        setIsInvalid(prevState => { return { ...prevState, phone2: true } });
        textInputs.phone2.current.focus();
        return false;
      }
      // email2
      if (!Validate.Email(props.emergencyContact2.email)) {
        setIsInvalid(prevState => { return { ...prevState, email2: true } });
        textInputs.email2.current.focus();
        return false;
      }
    }
    return true;
  };
  const skipEmergencyContacts = () => {
    props.setSkipEmergency(true);
    nextScreen();
  }
  const nextScreen = async () => {
    console.log('nextScreen() props.isContractor: ', props.isContractor);
    if (props.isContractor) {
      props.completeStep('EmergencyContacts');
    } else {
      try {
        setLoading(true);
        let signUpResult = await props.confirmDetails();
        console.log('emergency contacts signUpResult', signUpResult);
        setLoading(false);
      } catch (err) {
        console.log('emergency err', err);
        alert('Something went wrong, please try again later');
        setLoading(false);
      }
    }
  }
  const onChangeName1 = (input) => {
    if (isInvalid.name1 && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, name1: false } });
    }
    props.setEmergencyContact1(prevState => {
      return {
        ...prevState,
        name: input
      }
    });
  };
  const onChangePhone1 = (input) => {
    input = formatPhoneNumber(input);
    if (isInvalid.phone1 && Validate.PhoneNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, phone1: false } });
    }
    props.setEmergencyContact1(prevState => {
      return {
        ...prevState,
        phone: input
      }
    });
  };
  const onChangeEmail1 = (input) => {
    if (isInvalid.email1 && Validate.Email(input)) {
      setIsInvalid(prevState => { return { ...prevState, email1: false } });
    }
    props.setEmergencyContact1(prevState => {
      return {
        ...prevState,
        email: input
      }
    });
  };
  const onChangeRelationship1 = (input) => {
    if (isInvalid.relationship1 && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, relationship1: false } });
    }
    props.setEmergencyContact1(prevState => {
      return {
        ...prevState,
        relationship: input
      }
    });
  };
  const onChangeName2 = (input) => {
    if (isInvalid.name2 && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, name2: false } });
    }
    props.setEmergencyContact2(prevState => {
      return {
        ...prevState,
        name: input
      }
    });
  };
  const onChangePhone2 = (input) => {
    input = formatPhoneNumber(input);
    if (isInvalid.phone2 && Validate.PhoneNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, phone2: false } });
    }
    props.setEmergencyContact2(prevState => {
      return {
        ...prevState,
        phone: input
      }
    });
  };
  const onChangeEmail2 = (input) => {
    if (isInvalid.email2 && Validate.Email(input)) {
      setIsInvalid(prevState => { return { ...prevState, email2: false } });
    }
    props.setEmergencyContact2(prevState => {
      return {
        ...prevState,
        email: input
      }
    });
  };
  const onChangeRelationship2 = (input) => {
    if (isInvalid.relationship2 && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, relationship2: false } });
    }
    props.setEmergencyContact2(prevState => {
      return {
        ...prevState,
        relationship: input
      }
    });
  };

  const goBack = () => {
    if (props.navigation.canGoBack()) {
      props.navigation.goBack();
    } else {
      linkTo('/signup/verifyidentity');
    }
  }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' extraHeight={headerHeight + 20} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]} style={styles.container}>
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Emergency Contacts</Text>
        </TouchableOpacity>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>We use push notifications, SMS, email and telephone calls to communicate directly with you. If something terrible should happen to you, and we can't get ahold of you during a dispute or the releasing of funds, we will reach out to the contacts you provide below to help locate your whereabouts. This is completely optional.</Text>
        <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Emergency Contact #1</Text>
        <TextInputContainer
          iconName='user'
          placeholder='Full Name'
          textContentType='name'
          onChangeText={(t) => onChangeName1(t)}
          inputRef={textInputs.name1}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.name1}
          value={props.emergencyContact1.name}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={() => textInputs.phone1.current.focus()}
        />
        <TextInputContainer
          iconName='phone'
          placeholder='Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangePhone1(t)}
          value={props.emergencyContact1.phone}
          inputRef={textInputs.phone1}
          isInvalid={isInvalid.phone1}
          returnKeyType='done'
          onSubmitEditing={() => textInputs.email1.current.focus()}
        />
        <TextInputContainer
          iconName='envelope'
          placeholder='Email Address'
          textContentType='username'
          onChangeText={(t) => onChangeEmail1(t)}
          inputRef={textInputs.email1}
          keyboardType='email-address'
          // autoFocus={true} 
          isInvalid={isInvalid.email1}
          value={props.emergencyContact1.email}
          autoCapitalize='none'
          autoCompleteType='username'
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={() => textInputs.relationship1.current.focus()}
        />
        <TextInputContainer
          iconName='user'
          placeholder='Relationship'
          textContentType='none'
          onChangeText={(t) => onChangeRelationship1(t)}
          inputRef={textInputs.relationship1}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.relationship1}
          value={props.emergencyContact1.relationship}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={() => textInputs.name2.current.focus()}
        />

        <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Emergency Contact #2</Text>
        <TextInputContainer
          iconName='user'
          placeholder='Full Name'
          textContentType='name'
          onChangeText={(t) => onChangeName2(t)}
          inputRef={textInputs.name2}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.name2}
          value={props.emergencyContact2.name}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={() => textInputs.phone2.current.focus()}
        />
        <TextInputContainer
          iconName='phone'
          placeholder='Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangePhone2(t)}
          value={props.emergencyContact2.phone}
          inputRef={textInputs.phone2}
          isInvalid={isInvalid.phone2}
          returnKeyType='done'
          onSubmitEditing={() => textInputs.email2.current.focus()}
        />
        <TextInputContainer
          iconName='envelope'
          placeholder='Email Address'
          textContentType='username'
          onChangeText={(t) => onChangeEmail2(t)}
          inputRef={textInputs.email2}
          keyboardType='email-address'
          // autoFocus={true} 
          isInvalid={isInvalid.email2}
          value={props.emergencyContact2.email}
          autoCapitalize='none'
          autoCompleteType='username'
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={() => textInputs.relationship2.current.focus()}
        />
        <TextInputContainer
          iconName='user'
          placeholder='Relationship'
          textContentType='none'
          onChangeText={(t) => onChangeRelationship2(t)}
          inputRef={textInputs.relationship2}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.relationship2}
          value={props.emergencyContact2.relationship}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='next'
          onSubmitEditing={checkEmergencyContacts}
        />
        
        <View style={[CS.rowContainer, CS.buttons, { marginTop: 'auto'}]}>
          <View style={CS.buttonLeft}>
            <Button text='Skip' onPress={() => skipEmergencyContacts} color='blue' />
          </View>
          <View style={CS.buttonRight}>
            <Button text={props.isContractor ? 'Continue' : 'Sign Up'} onPress={() => checkEmergencyContacts} />
          </View>
        </View>
      </KeyboardAwareScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginVertical: 10,
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  scrollView: {
    // backgroundColor: 'yellow',
    width: '100%',
    flex: 1,
  },
  switchContainer: {
    marginVertical: 20,
  },
  switch: {
    marginRight: 10,
  },
  tabButtons: {
    marginLeft: 'auto',
  },
  tabButtonContainer: {
    paddingVertical: 10,
    paddingHorizontal: 30,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: Colors.lightBlue,
  },
  tabButtonContainerActive: {
    backgroundColor: Colors.yellow,
    borderColor: Colors.yellow,
  },
  tabButton: {
    color: Colors.lightText,
    textAlign: 'center',
    fontSize: 20,
  },
  tabButtonActive: {
    color: Colors.darkText,
  },
  left: {
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  right: {
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
  },
  contractorText: {
    textAlign: 'right',
    flex: 1,
    marginRight: 10,
  },
});

export default React.memo(EmergencyContacts);